// extracted by mini-css-extract-plugin
module.exports = {"scratch":"styles-module__scratch___1gM3v"};